import Link from 'next/link'
import { useRouter } from 'next/router'
import { memo, useMemo } from 'react'
import styled from 'styled-components'
import { linkCSS } from 'styles/common'
import { CROSS_APP_LINKS } from '../constants'
import NavDropdown from './NavDropdown'

const Menu = memo(() => {
	const { asPath } = useRouter()
	const activeLink = useMemo(() => {
		return CROSS_APP_LINKS.find((item) => item.link.includes(asPath.split('/')[1]))?.link
	}, [asPath])
	return (
		<>
			{CROSS_APP_LINKS.map(({ dropdown, link }) => {
				if (dropdown) {
					return <NavDropdown key={link} i18nLabel={''} {...dropdown} />
				}
				return (
					<Link key={link} href={link}>
						<MenuInside $isActive={link === activeLink}>{'Nav'}</MenuInside>
					</Link>
				)
			})}
		</>
	)
})

const MenuInside = styled.div<{ $isActive: boolean; $isDropDown?: boolean }>`
	${linkCSS};
	padding: ${(props) => (props.$isDropDown ? '4px 9px' : '0px')};
	font-weight: 400;
	font-size: 14px;
	text-transform: capitalize;
	text-align: center;
	border-radius: 100px;
	background: transparent;
	cursor: pointer;
	width: 100%;
	color: ${(props) => props.theme.colors.selectedTheme.button.text.primary};
	opacity: ${(props) => (props.$isActive ? 1 : 0.5)};
	&:hover {
		opacity: 1;
	}
	transition: all 0.2s ease-in-out;
`

export default Menu
